import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import financialTransactionsApi from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.ts';
import { FinancialTransactionFormData } from '@/features/dashboard/financialTransactions/schemas/financialTransactionSchema.ts';
import { financialTransactionRequestDtoMapper } from '@/features/dashboard/financialTransactions/types/FinancialTransactionRequestDto.mapper.ts';
import { FinancialTransactionErrorKeys } from '@/features/dashboard/financialTransactions/api/financialTransactionErrors.ts';
import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useUpdateFinancialTransaction = (transactionId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: FinancialTransactionFormData) => {
      const request =
        financialTransactionRequestDtoMapper.fromFormToUpdateRequest(formData);
      return financialTransactionsApi.update(transactionId, request);
    },
    onSuccess: () => {
      invalidateFinanceRelatedQueries(queryClient);
      toast.success('Transakcja została zaktualizowana');
    },
    onError: (error: Error) => {
      if (
        isKnownBackendErrorKey(
          error,
          FinancialTransactionErrorKeys.ALLOCATIONS_EXCEED_AMOUNT,
        )
      ) {
        toast.error('Nie można zapisać transakcji', {
          description: 'Suma przypisań przekracza kwotę transakcji.',
        });
        return;
      }
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się zaktualizować transakcji',
      });
    },
  });
};

export default useUpdateFinancialTransaction;
